import React from 'react'
import PropTypes from 'prop-types'

const EventListingPerson = props => {
  const role = props.role ? `${props.role}` : '';

  return (
    <li className="event-listing-person">
      {!!props.image && <img className="event-listing-person__image" src={props.image} alt={props.longName} />}
      <div
        className="event-listing-person__content rte__wrapper basic-rte"
        dangerouslySetInnerHTML={{ __html: props.longName + role }}
      />
    </li>
  )
}

EventListingPerson.propTypes = {
  role: PropTypes.string,
  image: PropTypes.string,
  longName: PropTypes.string.isRequired
}

export default EventListingPerson;
